export default {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  }
}
